import { appLogger } from 'app-lib/helpers/logging';

const logger = appLogger.create('User Helper');
import {valueAttendee, valueOrganizer} from '../mixpanel/mixpanelTracker';

export function getMyChannelKey(identity) {
    return identity && identity.channelInfo && identity.channelInfo.organizerChannels &&
    identity.channelInfo.organizerChannels[0] && identity.channelInfo.organizerChannels[0].channelKey ?
        identity.channelInfo.organizerChannels[0].channelKey : '';
}

export function getUserId(identity) {
    return (identity && identity.me && identity.me.id) ? identity.me.id : null;
}

export function isWDCEnabledUser(identity) {
    return (identity && identity.hasEntitlements);
}

export function isWDCEnabledUserWithChannels(identity) {
    return (isWDCEnabledUser(identity) && this.getMyChannelKey(identity));
}

export function validateIdentity(identity) {
    return (!identity.isError && identity.me) ? Promise.resolve(identity) : Promise.reject(identity);
}

export function getUserType(identity) {
    if (!identity) {
        logger.warn('Cannot get user type without identity');
        return null;
    }
    let userType = 'PUBLIC';
    const isWDCEnabled = isWDCEnabledUser(identity);
    if (isWDCEnabled) {
        userType = valueOrganizer;
    } else if (!isWDCEnabled && identity.me) {
        userType = valueAttendee;
    }
    return userType;
}

export function userIdentityFailed(identity) {
    const errorObj = {};
    errorObj.me = (identity && identity.me) ? identity.me : null;
    errorObj.error = (identity && identity.error) ? identity.error : null;
    errorObj.auth = (this.props.auth && this.props.auth.isLoggedIn) ? this.props.auth.isLoggedIn : null;

    logger.error('Identity fetch done but unable to get the identity', errorObj);
    return identity;
}




// WEBPACK FOOTER //
// ./src/app-lib/helpers/user-helper.js